module.exports = __webpack_public_path__ + "static/media/template7-carousel.e686e841.webp";